import React from 'react';

import { FlagKey } from 'api/types';
import useFeatureFlags from 'hooks/useFeatureFlags';
import Onboarding from 'modules/status/screens/Onboarding/Onboarding';
import Status from 'modules/status/screens/Status';
import { getDashboardRedirectPath } from 'modules/auth/Auth.utils';
import { Navigate, useLocation } from 'react-router';
import useUser from 'hooks/useUser';
import pages from 'pages';

export function StatusWrapper() {
  const { userResult, selectedAgreement } = useUser();
  const location = useLocation();

  const {
    flags: { [FlagKey.onboardingRefresh]: onboardingRefresh },
  } = useFeatureFlags();

  const { hasDashboardAccess } = getDashboardRedirectPath(
    userResult?.user || undefined,
    selectedAgreement,
    onboardingRefresh,
  );

  if (hasDashboardAccess) {
    return <Navigate to={`/${pages.DASHBOARD}`} replace state={{ path: location.pathname }} />;
  }

  return onboardingRefresh ? <Onboarding /> : <Status />;
}

export default StatusWrapper;
